<template>
  <nav>
    <div class="window-overlay" @click.self.stop="hide()" />
    <div class="dropdown-content" :style="{ paddingTop: `${paddingTop}px` }">
      <slot></slot>
    </div>
  </nav>
</template>

<script lang="ts">
import Vue from "vue";
export default Vue.extend({
  name: "components-dropdown-menu",
  props: {
    width: { type: Number, default: 150 },
    height: { type: Number, default: 150 },
    paddingTop: { type: Number, default: 8 },
  },
  methods: {
    hide(): void {
      this.$emit("hide");
    },
  },
});
</script>

<style lang="scss" scoped>
@import "~@vacancorp/vacan-scss/mixins/shadows.scss";
@import "~@vacancorp/vacan-scss/variables/colors.scss";
@import "~@vacancorp/vacan-scss/variables/generic.scss";
nav {
  $overlay-z-index: 9900;
  $popover-base-z-index: 9990;
  $popover-contents-z-index: 9991;
  @include z-depth-1();
  position: absolute;
  background-color: $white;
  border-radius: $border-radius;
  z-index: $popover-base-z-index;
  .dropdown-content {
    position: relative;
    width: 100%;
    max-width: 100%;
    height: auto;
    max-height: inherit;
    padding: 8px 0;
    box-sizing: border-box;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    z-index: $popover-contents-z-index;
  }
  .window-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: transparent;
    z-index: $overlay-z-index;
  }
}
</style>
